import { Link } from 'react-router-dom'
export function NotFound() {
  return <div className="container notfound"><h1>That page wandered off.</h1><p style={{ color: 'var(--muted)' }}>Let's get you back to the good stuff.</p><Link to="/" className="btn" style={{ marginTop: 16 }}>Home</Link></div>
}
